/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import { useEventLogging } from '@packages/jslib'

import Aside from '@components/Layout/Aside'
import Footer from '@components/Layout/Footer'
import Header from '@components/Layout/Header'
import SubmitModal from '@components/SubmitModal'
import useViewResultModeStore from 'store/viewResultMode'
import useCurrentPage from '@hooks/useCurrentPage'
import useExamInform from '@hooks/useExamInform'
import { classNames, getCookie } from '@lib/simpleFn'
import { CommentaryVideoBanner } from '@components/CommentaryVideoBanner'

type ExamLayoutProps = {
  children: React.ReactNode
  header?: boolean
  headerSubmitMode?: boolean
  aside?: boolean
  footer?: boolean
  timeout?: boolean
  setTimeout?: (truFalse: boolean) => void
  disableTimer?: boolean
  trackPageName?: string
  trackProperties?: { [key: string]: any }
  title?: string
  isDelivery?: boolean
}

const Layout: React.FC<ExamLayoutProps> = ({
  children,
  header,
  headerSubmitMode,
  aside,
  footer,
  timeout,
  setTimeout,
  disableTimer,
  trackPageName,
  trackProperties,
  title,
  isDelivery,
}) => {
  const { viewResultMode } = useViewResultModeStore()
  const [showSubmitModal, setShowSubmitModal] = useState(false)
  const {
    currentPage,
    totalPage,
    bottomNumber,
    goToQuestion: moveQuestion,
  } = useCurrentPage(isDelivery)

  const [questionGroupTitle, setQuestionGroupTitle] = useState('')
  const [userName, setUserName] = useState('홍길동')

  const { currentQuestionGroup } = useExamInform(isDelivery)

  const { trackPageView } = useEventLogging()

  useEffect(() => {
    if (trackPageName) {
      trackPageView({
        pageName: trackPageName,
        properties: trackProperties ? trackProperties : {},
      })
    }
  }, [])

  useEffect(() => {
    const appUser = JSON.parse(getCookie('app_user') || '{}')
    setUserName(decodeURI(appUser['name']) || '홍길동')
  }, [])

  useEffect(() => {
    setQuestionGroupTitle(currentQuestionGroup.title)
  }, [currentQuestionGroup.title])

  const goToQuestion = useCallback((num: number) => moveQuestion(num), [moveQuestion])

  const headerProps = {
    showSubmitModal,
    setShowSubmitModal,
    viewResultMode,
    groupTitle: title || questionGroupTitle,
    headerSubmitMode,
    setTimeout,
    isTimerDisabled: !!disableTimer,
    userName,
  }

  const asideProps = {
    goToQuestion,
    isDelivery,
  }

  const footerProps = {
    viewResultMode,
    setShowSubmitModal,
    currentPage,
    totalPage,
    bottomNumber,
    isDelivery,
  }

  return (
    <div className={'min-h-screen flex flex-col'}>
      {!headerSubmitMode && (
        <SubmitModal
          show={showSubmitModal}
          setShow={setShowSubmitModal}
          timeout={timeout}
          isDelivery={isDelivery}
        />
      )}
      <div className={'h-[100vh] flex flex-col overflow-x-auto'}>
        {header && <Header {...headerProps} />}
        <section
          className={classNames(
            'flex-1 flex flex-col sm:flex-row sm:max-h-[calc(100vh)] overflow-scroll overflow-x-scroll lg:overflow-x-auto',
            footer ? 'max-h-[calc(100vh)]' : 'max-h-[calc(100vh+160px)]' // footer가 사라지면 footer 길이(h-20: 80px) 만큼 하단 여백 조정
          )}
        >
          <div className={'flex-1 gap-0 overflow-auto'}>
            {viewResultMode && currentQuestionGroup.commentaryVideo && (
              <CommentaryVideoBanner video={currentQuestionGroup.commentaryVideo} />
            )}
            <div className="flex max-md:px-4 justify-center pt-16 max-md:pt-6">{children}</div>
          </div>
          {aside && <Aside {...asideProps} />}
        </section>
        {footer && <Footer {...footerProps} />}
      </div>
    </div>
  )
}

export default Layout
